// A real presigned thumbnail for an image asset, an icon otherwise (media-ux
// ruling: the rail never shows just filenames). Bytes stream straight from
// the bucket via the short-lived URL; S3 keys never reach the client.
import { FileText, Film, ImageOff } from '../../lib/icons';
import { useAssetUrl } from '../../data/hooks';
import { cn } from '../../lib/cn';

const BYTES_EXIST = new Set(['stored', 'normalized', 'understood']);

export default function AssetThumb({ asset, className }) {
  const isImage = asset.kind === 'image' && BYTES_EXIST.has(asset.status);
  const { data, isError } = useAssetUrl(isImage ? asset.id : null);

  const frame = cn(
    'flex items-center justify-center overflow-hidden rounded-md border border-border bg-secondary/50 text-muted-foreground',
    className
  );

  if (!isImage) {
    return (
      <span className={frame} aria-hidden="true">
        {asset.kind === 'video' ? <Film className="size-3.5" /> : <FileText className="size-3.5" />}
      </span>
    );
  }
  if (isError || !data?.url) {
    return (
      <span className={frame} aria-hidden="true">
        <ImageOff className="size-3.5 opacity-60" />
      </span>
    );
  }
  return (
    <span className={frame}>
      {/* Presigned URLs can't go through next/image's optimizer (bytes must
          bypass Vercel — the M1 presign invariant), so a plain img is
          deliberate here. */}
      <img
        src={data.url}
        alt={asset.original_name || `Asset ${asset.id}`}
        loading="lazy"
        className="h-full w-full object-cover"
      />
    </span>
  );
}